import { cn } from "@/lib/utils";
import { CheckCircle2, Clock, AlertTriangle, Copy } from "lucide-react";

export const DuplicateBadge = ({ className }) => (
  <span data-testid="duplicate-badge" className={cn("inline-flex items-center gap-1 rounded-sm border border-orange-600 bg-orange-950 px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest text-orange-300", className)}>
    <Copy className="h-3 w-3" /> Duplicate
  </span>
);

const MP = {
  amazon: "bg-[#1E293B] text-[#F59E0B] border-[#F59E0B]/60",
  flipkart: "bg-[#1E3A8A] text-[#60A5FA] border-[#2563EB]",
  firstcry: "bg-[#831843] text-[#F472B6] border-[#DB2777]",
  myntra: "bg-[#581C87] text-[#E879F9] border-[#A21CAF]",
  unknown: "bg-slate-800 text-slate-300 border-slate-600",
};

export const MarketplaceBadge = ({ marketplace, className }) => (
  <span data-testid={`marketplace-badge-${marketplace}`}
    className={cn("inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest", MP[marketplace] || MP.unknown, className)}>
    {marketplace || "unknown"}
  </span>
);

export const StatusBadge = ({ status, matched = true, className }) => {
  if (!matched) {
    return (
      <span data-testid="status-badge-unmatched" className={cn("inline-flex items-center gap-1 rounded-sm border border-[#DC2626] bg-[#7F1D1D] px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest text-[#FCA5A5]", className)}>
        <AlertTriangle className="h-3 w-3" /> Unmatched
      </span>
    );
  }
  if (status === "printed") {
    return (
      <span data-testid="status-badge-printed" className={cn("pop inline-flex items-center gap-1 rounded-sm border border-[#059669] bg-[#064E3B] px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest text-[#34D399]", className)}>
        <CheckCircle2 className="h-3 w-3" /> Printed
      </span>
    );
  }
  return (
    <span data-testid="status-badge-pending" className={cn("inline-flex items-center gap-1 rounded-sm border border-[#D97706] bg-[#78350F] px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest text-[#FBBF24]", className)}>
      <Clock className="h-3 w-3" /> Pending
    </span>
  );
};
